import { render } from "./MailHome.vue?vue&type=template&id=78b418d2"
import script from "./MailHome.vue?vue&type=script&lang=js"
export * from "./MailHome.vue?vue&type=script&lang=js"

import exportComponent from "/home/ben/Projects/harborwall-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__